export enum TabsEnum {
    PEOPLE = 'personas',
    BUSINESS = 'empresas',
}

export enum DocumentType {
    'CO1C' = 'CC',
    'CO1D' = 'DE',
    'CO1E' = 'CE',
    'CO1L' = 'RC',
    'CO1N' = 'NIT',
    'CO1P' = 'Pasapt.',
    'CO1R' = 'SP',
    'CO1S' = 'N/A',
    'CO1T' = 'TI',
    'CO1U' = 'NIUP',
    'CO1V' = 'PP',
    'CO1X' = 'TE',
}
